/*
 * Copyright (c) 2019. Sonrai Analytics Ltd.
 * Developed by Deva Sen. & Warren Dowey
 */

export class AppDetailsModel {

  private _appDetailsId?: string;
  private _appID?: string;
  private _appDesc?: string;
  private _analysisType?: string;
  private _useCases?: string;
  private _compatibleDatasets?: string;
  private _otherTag?: string;
  private _appImg: string;
  private _appVideoSafeUrl: string;
  private _appName?: string;

  constructor(
    appDetailsId?: string,
    appID?: string,
    appDesc?: string,
    analysisType?: string,
    useCases?: string,
    compatibleDatasets?: string,
    otherTag?: string,
    appImg?: string,
    appVideoSafeURL?: string,
    appName?: string
  ) {
    this._appDetailsId = appDetailsId;
    this._appID = appID;
    this._appDesc = appDesc;
    this._analysisType = analysisType;
    this._useCases = useCases;
    this._compatibleDatasets = compatibleDatasets;
    this._otherTag = otherTag;
    this._appImg = appImg;
    this._appVideoSafeUrl = appVideoSafeURL;
    this._appName = appName;
  }

  get appDetailsId(): string {
    return this._appDetailsId;
  }

  set appDetailsId(value: string) {
    this._appDetailsId = value;
  }

  get appID(): string {
    return this._appID;
  }

  set appID(value: string) {
    this._appID = value;
  }

  get appDesc(): string {
    return this._appDesc;
  }

  set appDesc(value: string) {
    this._appDesc = value;
  }

  get analysisType(): string {
    return this._analysisType;
  }

  set analysisType(value: string) {
    this._analysisType = value;
  }

  get useCases(): string {
    return this._useCases;
  }

  set useCases(value: string) {
    this._useCases = value;
  }

  get compatibleDatasets(): string {
    return this._compatibleDatasets;
  }

  set compatibleDatasets(value: string) {
    this._compatibleDatasets = value;
  }

  get otherTag(): string {
    return this._otherTag;
  }

  set otherTag(value: string) {
    this._otherTag = value;
  }

  get appName(): string {
    return this._appName;
  }

  set appName(value: string) {
    this._appName = value;
  }


  get appImg(): string {
    return this._appImg;
  }

  set appImg(value: string) {
    this._appImg = value;
  }

  get appVideoSafeUrl(): string {
    return this._appVideoSafeUrl;
  }

  set appVideoSafeUrl(value: string) {
    this._appVideoSafeUrl = value;

  }

  toJson(): Object {
    const object = {
      app_details_id: this.appDetailsId,
      app_id: this.appID,
      app_description: this.appDesc,
      analysis_type: this.analysisType,
      use_cases: this.useCases,
      compatible_data: this.compatibleDatasets,
      other_tag: this.otherTag,
    };
    Object.keys(object).forEach(k => !object[k] && object[k] !== undefined && delete object[k]);
    return object;
  }

  fromJson(input: any) {
    let otherTag;
    if (input['other_tag']) {
      otherTag = input['other_tag'].split(',')
    } else {
      otherTag = null;
    }
    return new AppDetailsModel(
      input['apps_details_id'],
      input['app_id'],
      input['app_description'],
      input['analysis_type'],
      input['use_cases'],
      input['compatible_datasets'].split(','),
      otherTag,
      input['app_image'],
      input['app_video'],
    );
  }

}
